import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, Input } from 'reactstrap';
import './FeedbackDialogue.scss';
import FeedbackOptions from './FeedbackOptions';
import { connect } from 'react-redux';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as sideBarActions from '../../redux/sideBarActions';
import * as pageControllerActions from '../../redux/pageControllerActions';
import * as gaHelpers from '../../utilities/GAHelpers/GAHelpers';
import { bindActionCreators } from 'redux';
import * as Constants from '../../utilities/constants/Constants';
import { string } from '../../localization';
import * as CookieUtils from '../../utilities/CookieUtils/CookieUtils';
import { checkForPage } from '../../utilities/HelperFunctions/HelperFunctions';
import * as signageHelperFunctions from '../../utilities/HelperFunctions/SignageHelperFunctions';

class FeedbackDialogue extends Component {
  state = {
    feedbackOptions: [
      {
        label: string.VERY_SATISFIED_BUTTON_TEXT,
        key: Constants.GA_EVENET_LABEL.VERY_SATISFIED_BUTTON_TEXT
      },
      {
        label: string.SATISFIED_BUTTON_TEXT,
        key: Constants.GA_EVENET_LABEL.SATISFIED_BUTTON_TEXT
      },
      {
        label: string.DISSATISFIED_BUTTON_TEXT,
        key: Constants.GA_EVENET_LABEL.DISSATISFIED_BUTTON_TEXT
      },
      {
        label: string.VERY_DISSATISFIED_BUTTON_TEXT,
        key: Constants.GA_EVENET_LABEL.VERY_DISSATISFIED_BUTTON_TEXT
      }
    ]
  };

  handelProjectSubmissionOnfeedback = () => {
    const { projectSubmissionState, dispatchers } = this.props;
    if (
      projectSubmissionState ===
      Constants.PROJECT_SUBMISSION_STATE.CONTINUE_ON_CLOSE_STATE
    ) {
      dispatchers.fabricCanvasActions.setProjectSubmissionState(
        Constants.PROJECT_SUBMISSION_STATE.SUBMIT_STATE
      );
    }
  };

  handleCheck = (e, index) => {
    const { dispatchers } = this.props;
    const { feedbackOptions } = this.state;
    dispatchers.fabricCanvasActions.setFeedbackRating(feedbackOptions[index]);
  };

  handleCheckbox = e => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.setFeedbackPermission(e.target.checked);
  };

  handleCookies = () => {
    const { feedbackDuration } = this.props;
    CookieUtils.saveFeedbackActivityCookie(feedbackDuration);
  };

  handleOKClick = () => {
    this.sendFeedbackData(Constants.SUBMITTED_KEY);
  };

  handleCancelClick = () => {
    this.sendFeedbackData(Constants.REJECTED_KEY);
  };

  sendFeedbackData = key => {
    const {
      dispatchers,
      onDisplay,
      page,
      envData,
      feedbackReview,
      feedbackRating,
      feedbackPermission,
      store,
      project
    } = this.props;
    dispatchers.fabricCanvasActions.setFeedbackDialogue(false);
    dispatchers.fabricCanvasActions.setFeedbackState(false);
    this.handleCookies();
    onDisplay();
    const productId = dispatchers.fabricCanvasActions.fetchProductId();
    const feedbackStage = checkForPage(page);
    let rating = '';
    let review = '';
    let action = null;
    let labelName = '';

    const envPlatform = envData.platform;
    const platform =
      envPlatform === Constants.ANDROID || envPlatform === Constants.IOS
        ? Constants.MOBILE
        : Constants.DESKTOP;

    let deviceType = Constants.DESKTOP;
    if (envPlatform === Constants.ANDROID) {
      deviceType = Constants.ANDROID_WEB_APP;
    } else if (envPlatform === Constants.IOS) {
      deviceType = Constants.IOS_WEB_APP;
    }

    if (key === Constants.SUBMITTED_KEY) {
      review = feedbackReview !== null ? feedbackReview : '';
      rating = feedbackRating;
      action = Constants.GA_EVENT_ACTIONS.FEEDBACK_SUBMITTED;
      labelName = this.checkForOptionState(Constants.SUBMITTED_KEY);
    } else {
      rating = '-';
      action = Constants.GA_EVENT_ACTIONS.FEEDBACK_CANCELLED;
      labelName = this.checkForOptionState(Constants.REJECTED_KEY);
    }

    const data = {
      customer_email: project.customerEmail,
      store_id: store.id,
      product_id: productId,
      project_group_id: project.projectGroupId,
      project_id: project.id,
      rating_level: rating,
      description: review,
      submission_type: key,
      feedback_stage: feedbackStage,
      platform,
      allow_hp_to_contact: feedbackPermission,
      device_type: deviceType
    };
    const feedbackDetails = JSON.stringify(data);
    const postData = `request=${feedbackDetails}`;
    dispatchers.fabricCanvasActions.sendFeedbackDetails(postData, () => {
      this.handelProjectSubmissionOnfeedback();
      dispatchers.gaHelpers.feedbackGAEvents(rating, action, labelName);
    });
  };

  checkForOptionState = key => {
    const {
      project,
      envData,
      page,
      feedbackRating,
      feedbackReview,
      dispatchers
    } = this.props;
    const tempArray = [];
    let singleValue = '';
    const envPlatform = envData.platform;
    const platform =
      envPlatform === Constants.ANDROID || envPlatform === Constants.IOS
        ? Constants.MOBILE
        : Constants.DESKTOP;

    const pageName = checkForPage(page);
    tempArray.push(pageName);

    if (key === Constants.SUBMITTED_KEY) {
      const option = feedbackRating;
      tempArray.push(option);
      if (feedbackReview !== null) {
        tempArray.push(feedbackReview);
      }
    } else {
      tempArray.push(Constants.GA_EVENET_LABEL.FEEDBACK_CANCELLED);
    }

    if (project.name) {
      tempArray.push(project.name);
    }
    if (platform) {
      tempArray.push(platform);
    }
    const label = dispatchers.fabricCanvasActions.checkForPosterVersionName();
    if (label) {
      tempArray.push(label);
    }
    singleValue = tempArray.join(' | ');
    return singleValue;
  };

  setReview = e => {
    const { dispatchers } = this.props;
    if (Object.prototype.hasOwnProperty.call(e.target, 'value')) {
      dispatchers.fabricCanvasActions.setFeedbackReview(e.target.value);
    }
  };

  render() {
    const {
      showFeedbackDialogue,
      feedbackRating,
      feedbackReview,
      dispatchers
    } = this.props;
    const { feedbackOptions } = this.state;
    const controlStyle =
      feedbackRating != ''
        ? 'feedback-ok-btn-enabled'
        : 'feedback-ok-btn-disabled';
    const className = `feedback-ok-btn ${controlStyle}`;

    return (
      <div>
        <Modal
          className='feedback-modal'
          isOpen={showFeedbackDialogue}
          contentClassName='border-0 bg-transparent'
          backdropClassName='feedback-backdrop'
          centered
        >
          <ModalBody className='rounded-1'>
            <ModalHeader
              className='p-0 border-0'
              close={
                <button
                  type='button'
                  className='close pt-0 pb-0'
                  onClick={this.handleCancelClick}
                >
                  &times;
                </button>
              }
            >
              <p className='feedback-header'>{string.HP_FEEDBACK_TEXT}</p>
            </ModalHeader>
            <div className='feedback-header-container'>
              <p className='feedback-sub-header'>
                {string.FEEDBACK_QUERY_TEXT}
              </p>
              <div className='feedback-options-container'>
                {feedbackOptions.map((option, index) => (
                  <FeedbackOptions
                    label={option.label}
                    onchange={e => this.handleCheck(e, index)}
                    isChecked={feedbackRating === feedbackOptions[index].key}
                    index={index}
                    key={option.key}
                  />
                ))}
              </div>

              <div>
                <p>{string.FEEDBACK_IMPROVE_TEXT}</p>

                <Input
                  type='textarea'
                  name='customText'
                  id='feedback-text'
                  placeholder={string.FEEDBACK_PLACEHOLDER_TEXT}
                  value={feedbackReview}
                  onChange={this.setReview}
                />
                <div
                  className='custom-control custom-checkbox'
                  style={{ marginBottom: '20px' }}
                >
                  <input
                    type='checkbox'
                    className='custom-control-input'
                    id='customCheck1'
                    onChange={e => this.handleCheckbox(e)}
                  />
                  <label
                    htmlFor='customCheck1'
                    className='custom-control-label'
                  >
                    {string.FEEDBACK_PERMISSION_STRING_KEY}
                  </label>
                </div>
                <div>
                  <a
                    href={
                      dispatchers.signageHelperFunctions.isFranceAccount()
                        ? Constants.PRIVACY_STATEMENT_FRANCE
                        : Constants.PRIVACY_STATEMENT
                    }
                    className='feedback-txt'
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    {string.FEEDBACK_PRIVACY_INFO_TEXT}
                  </a>

                  <button
                    type='button'
                    className={className}
                    disabled={feedbackRating == ''}
                    onClick={feedbackRating != '' ? this.handleOKClick : null}
                  >
                    <span className='error-label'>
                      {string.SUBMIT_BUTTON_KEY}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    page: state.pageController.currentPageIndex,
    project: state.finalCheck.project,
    showFeedbackDialogue: state.fabricCanvas.showFeedbackDialogue,
    category: state.modal.envData.category,
    feedbackDuration: state.modal.envData.feedback_duration,
    projectSubmissionState: state.fabricCanvas.projectSubmissionState,
    envData: state.modal.envData,
    store: state.modal.storeData,
    feedbackRating: state.fabricCanvas.feedbackRating,
    feedbackReview: state.fabricCanvas.feedbackReview,
    feedbackPermission: state.fabricCanvas.feedbackPermission
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      signageHelperFunctions: bindActionCreators(
        signageHelperFunctions,
        dispatch
      ),
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackDialogue);
